import { Injectable } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { CampaignVO } from 'src/app/data/vo/CampaignVO';
import { ModalService } from 'src/app/services/modal.service';


@Injectable()
export class CampaignService {
    suggestedCampaign: FormControl;
    selectedSuggestedCamapignData: CampaignVO;
    suggestedCampaignUpdated = new Subject<CampaignVO>();

    constructor(private modal: ModalService) { }

    setSuggestedCampaign(suggestedCampaign: FormControl, selectedSuggestedCamapignData: CampaignVO) {
        this.suggestedCampaign = suggestedCampaign;
        this.selectedSuggestedCamapignData = selectedSuggestedCamapignData;
        this.suggestedCampaignUpdated.next(selectedSuggestedCamapignData);
    }

    getSuggestedCampaignUpdated(): Observable<CampaignVO> {
        return this.suggestedCampaignUpdated.asObservable();
    }

    resetSuggestedCampaign(confirmCallback?: () => void, cancelCallback?: () => void) {
        if (this.suggestedCampaign && this.suggestedCampaign.value) {
            this.modal.confirmation({ message: "This selection will reset your audience and goal settings. Are you sure you wish to continue?" }, "Confirm campaign selection", '',
                () => {
                    this.suggestedCampaign.setValue(null);
                    this.suggestedCampaignUpdated.next(null);
                    if (confirmCallback) {
                        confirmCallback();
                    }
                },
                () => {
                    if (cancelCallback) {
                        cancelCallback();
                    }
                },
                undefined,
                () => {
                    if (cancelCallback) {
                        cancelCallback();
                    }
                }
            );
        }
    }


}